import styled from 'styled-components'

export const ConversationTextStyled = styled.div`
  padding-top: ${(props) => props.theme.typography.pxToRem(24)};
  padding-bottom: ${(props) => props.theme.typography.pxToRem(16)};
`
